<template>
  <div class="modal fade" id="checkoutModal" tabindex="-1" role="dialog" aria-labelledby="checkoutModalLabel"
    aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content">
        <form id="checkout-form" name="checkout-form" @submit.prevent="submit()">
          <input type="hidden" name="action" value="send_inquiry_form" />
          <input type="text" class="website_hp" name="website_hp" />

          <!-- Modal header start -->
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4 class="modal-title" id="myModalLabel">{{ l('zavrsi_rezervaciju') }}</h4>
          </div>
          <!-- Modal header end -->

          <!-- Modal body start -->
          <div class="modal-body">
            <!-- Checkout Info start -->
            <div class="checkout-info-box">
              <h3>
                <i class="fa fa-info-circle"></i>
                {{ l('prije_zavrsetka_text') }}:
              </h3>
              <p>{{ l('voucher_text') }}:</p>
            </div>
            <!-- Checkout Info end -->

            <!-- Checkout Rental Info start -->
            <div class="checkout-vehicle-info">
              <div class="location-date-info">
                <h3>{{ l('lokacija_datum') }}</h3>
                <div class="info-box">
                  <span class="glyphicon glyphicon-calendar"></span>
                  <h4 class="info-box-title">{{ l('pick_up') }} {{ l('vrijeme') }}</h4>
                  <p class="info-box-description">
                    <span id="pick-up-date-ph"></span>
                    {{ form.start_date }} at {{ form.start_time }}
                    <span id="pick-up-time-ph"></span>
                  </p>
                  <input type="hidden" name="pick-up" id="pick-up" value />
                </div>
                <div class="info-box">
                  <span class="glyphicon glyphicon-calendar"></span>
                  <h4 class="info-box-title">{{ l('drop_off') }} {{ l('time') }}</h4>
                  <p class="info-box-description">
                    <span id="drop-off-date-ph"></span>
                    {{ form.stop_date }} at {{ form.stop_time }}
                    <span id="drop-off-time-ph"></span>
                  </p>
                  <input type="hidden" name="drop-off" id="drop-off" value />
                </div>
                <div class="info-box">
                  <span class="glyphicon glyphicon-map-marker"></span>
                  <h4 class="info-box-title">{{ l('pick_up') }} {{ l('lokacija') }}</h4>
                  <p class="info-box-description" id="pickup-location-ph" v-if="form.office_start_id">{{
                      form.office_start_id
                  }}</p>
                  <input type="hidden" name="pickup-location" id="pickup-location" value />
                </div>
                <div class="info-box">
                  <span class="glyphicon glyphicon-map-marker"></span>
                  <h4 class="info-box-title">{{ l('drop_off') }} {{ l('lokacija') }}</h4>
                  <p class="info-box-description" id="dropoff-location-ph" v-if="form.office_stop_id">{{
                      form.office_stop_id
                  }}</p>
                  <input type="hidden" name="dropoff-location" id="dropoff-location" value />
                </div>
              </div>

              <div class="vehicle-info">
                <h3 v-if="form.car">
                  {{ l('vozilo') }}: {{ form.car.full_name }} , {{ form.price }} {{ l('euro') }}
                  <span id="selected-car-ph"></span>
                </h3>
                <h6 v-if="form.price">
                  {{ l('vehicleprice') }} : {{ form.baseprice }} {{ l('euro') }}
                  {{ l('delivery') }} {{ form.office_start_id }} : {{ form.lokacijaprice }} {{ l('euro') }}
                  {{ l('pickup') }} {{ form.office_stop_id }} : {{ form.dlokacijaprice }} {{ l('euro') }}
                  <span id="selected-car-ph"></span>
                </h6>
                <a href="#vehicles" class="scroll-to"></a>
                <input type="hidden" name="selected-car" id="selected-car" value />
                <div class="clearfix"></div>
                <div class="vehicle-image">
                  <img v-if="form.car" class="img-responsive" id="selected-vehicle-image" :src="form.car.avatar"
                    alt="Vehicle" />
                </div>
              </div>

              <div class="clearfix"></div>
            </div>
            <!-- Checkout Rental Info end -->

            <hr />

            <!-- Checkout Personal Info start -->
            <!-- Checkout Address Info start -->
            <div v-if="form.office_start_id && form.office_start_id.includes('Airport')" class="checkout-address-info">
              <div class="form-group address">
                <label for="flight">{{ l('let') }}</label>
                <input v-model="form.flight" type="text" class="form-control" name="flight" id="flight"
                  :placeholder="l('unesi_svoj') + ' ' + l('let')" />
              </div>
            </div>
            <div v-else class="checkout-address-info">
              <div class="form-group left">
                <label for="padresa">{{ l('adresa') }}</label>
                <input v-model="form.padresa" type="text" class="form-control" name="padresa" id="padresa"
                  :placeholder="l('unesi_svoj') + ' ' + l('adresa')" />
              </div>
              <div class="form-group right">
                <label for="dadresa">{{ l('adresa') }}</label>
                <input v-model="form.dadresa" type="text" class="form-control" name="dadresa" id="dadresa"
                  :placeholder="l('unesi_svoj') + ' ' + l('adresa')" />
              </div>
            </div>
            <div class="checkout-personal-info">
              <div class="alert hidden" id="checkout-form-msg"></div>
              <h3>{{ l('personal_info') }}</h3>
              <div class="form-group left">
                <label for="first-name">{{ l('ime') }}:</label>
                <input v-model="form.first_name" type="text" class="form-control" name="first-name" id="first-name"
                  required :placeholder="l('unesi_svoj') + ' ' + l('ime')" />
              </div>
              <div class="form-group right">
                <label for="last-name">{{ l('prezime') }}:</label>
                <input v-model="form.last_name" type="text" class="form-control" name="last-name" id="last-name"
                  required :placeholder="l('unesi_svoj') + ' ' + l('prezime')" />
              </div>
              <div class="form-group left">
                <label for="phone-number text-capitalize">{{ l('telefon') }}:</label>
                <vue-tel-input type="number" v-model="form.phone_number" name="phone-number" id="phone-number" required
                  @open="open = true" @close="open = false" @country-changed="countryChanged" defaultCountry="AT">
                  <template v-slot:arrow-icon> <span v-if="open">▲</span>
                    <span v-else>▼</span> </template>
                </vue-tel-input>
              </div>
              <div class="form-group right age">
                <label for="age">{{ l('godine') }}:</label>
                <div class="styled-select-age">
                  <select name="age" id="age" v-model="form.age">
                    <option :value="i" v-for="i in years" :key="i">
                      {{
                          i
                      }}
                    </option>
                  </select>
                </div>
              </div>
              <div>
                <div class="form-group left">
                  <label for="email-address">{{ l('email') }}:</label>
                  <input type="email" class="form-control" name="email-address" id="email-address" required
                    :placeholder="l('unesite_email')" />
                </div>
                <div class="form-group right">
                  <label for="email-address-confirm">{{ l('potvrdi_email') }}:</label>
                  <input v-model="form.email" type="email" class="form-control" name="email-address-confirm"
                    id="email-address-confirm" required :placeholder="l('potvrdi_email')" />
                </div>
              </div>
              <div class="clearfix"></div>
            </div>
            <!-- Checkout Personal Info end -->

            <!-- Checkout Address Info start -->
            <div class="checkout-address-info">
              <div class="form-group address">
                <label for="address">{{ l('adresa') }}</label>
                <input v-model="form.user_address" type="text" class="form-control" name="address" id="address" required
                  :placeholder="l('unesi_svoj') + ' ' + l('adresa')" />
              </div>

              <div class="checkout-address-info">
                <div class="form-group address">
                  <label for="zip-code">{{ l('placanje') }}</label>
                  <div class="styled-select-age">
                    <select name="age" id="age" @change="onChange($event)" v-model="form.payment_type_id">
                      <option :value="i.id" v-for="(i, index) in payments" :key="index">{{ l(i.value) }}
                      </option>
                    </select>
                  </div>
                  <img src="/site/img/visa.png" class="img" style="width: 100px ; height: auto; margin-top: 10px;">
                </div>
              </div>
              <div class="form-group city">
                <label for="city">{{ l('grad') }}</label>
                <input v-model="form.user_city" type="text" class="form-control" name="city" id="city"
                  :placeholder="l('unesi_svoj') + ' ' + l('grad')" />
              </div>
              <div class="form-group zip-code">
                <label for="zip-code">{{ l('drzava') }}</label>
                <input v-model="form.zip" type="text" class="form-control" name="zip-code" id="zip-code" required
                  :placeholder="l('unesi_svoj') + ' ' + l('drzava')" />
              </div>
              <div class="clearfix"></div>
            </div>
            <!-- Checkout Address Info end -->

            <div class="newsletter">
              <div class="form-group">
                <div class="checkbox">
                  <input id="check1" type="checkbox" name="newsletter" value="yes" />
                  <label for="check1">{{ l('posaljite_mi_text') }}</label>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal body end -->

          <!-- Modal footer start -->
          <div class="modal-footer">
            <span class="btn-border btn-gray">
              <button type="button" class="btn btn-default btn-gray" data-dismiss="modal">{{ l('otkazi') }}</button>
            </span>
            <span class="btn-border btn-yellow">
              <button type="submit" class="btn btn-primary btn-yellow">{{ l('rezervisi') }}</button>
            </span>
          </div>
          <!-- Modal footer end -->
        </form>
      </div>
    </div>

    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
import { Forma } from "../../site";
import site from "../../mixins/site";
import Loading from "vue-loading-overlay";
import { VueTelInput } from "vue-tel-input";

// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import 'vue-tel-input/dist/vue-tel-input.css';

export default {
  props: ["langs"],
  mixins: [site],
  components: {
    Loading,
    VueTelInput,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      open: false,
      form: {

      },
      payments: [
        {
          id: 1,
          value: "Cache on Delivery"
        }
      ],

    };
  },
  computed: {
    years() {
      let out = [];
      for (let i = 18; i < 101; i++) {
        out.push(i);
      }
      return out;
    }
  },
  methods: {
    countryChanged(country) {
      this.form.phone_number = country.dialCode;
    },
    validate() {
    },
    onChange(event) {
      //  if (this.form.payment_type_id == 2) {
      //     console.log(event.target.value)
      //   }
      //  if (event.target.value == 2) {
      //     console.log(event.target.value)
      //   }
    },
    submit() {
      let form = this.transformSendForm(this.form);
      this.isLoading = true;
      if (form.payment_type_id == "2") {
        axios
          .post(this.domain + this.paths.reservation, form)
          .then(response => {
            for (let i in form) {
              form[i] = "";
            }

            for (let i in Forma.$data) {
              Forma.$data[i] = "";
            }

            setTimeout(() => {
              this.isLoading = false;
              Forma.$emit("clear-data");
              $("#checkoutModal").modal("hide");
              window.location.href = `/confirmorder/${this.form.email}`;
            }, 3000)
          })
          .catch(error => {
            this.isLoading = false;
            this.$swal("Error... Please try again later.");
          })

      } else {
        axios
          .post(this.domain + this.paths.reservation, form)
          .then(response => {
            for (let i in form) {
              form[i] = "";
            }

            for (let i in Forma.$data) {
              Forma.$data[i] = "";
            }

            Forma.$emit("clear-data");
            $("#checkoutModal").modal("hide");

            setTimeout(() => {
              this.$swal("Thank you for the order. Please check the email.");
            }, 300);
            this.isLoading = false;
          })
          .catch(error => {
            this.isLoading = false;
            this.$swal("Error... Please try again later.");
          });
      }
      setTimeout(() => {
        this.isLoading = false
      }, 5000)
    }
  },
  created() {
    let self = this;
    Forma.$on("refresh-form", r => {
      self.form = Object.assign({}, Forma.$data);
      this.form.phone_number = '43';
      // console.log(JSON.stringify(Forma.$data.price));
      // console.log(JSON.stringify(self.form.price));
    });
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/site/ModalForma.vue